import { render, staticRenderFns } from "./AppNavItem.vue?vue&type=template&id=a4ec0500&scoped=true"
import script from "./AppNavItem.vue?vue&type=script&lang=js"
export * from "./AppNavItem.vue?vue&type=script&lang=js"
import style0 from "./AppNavItem.vue?vue&type=style&index=0&id=a4ec0500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec0500",
  null
  
)

export default component.exports